import React from 'react';
import PropTypes from 'prop-types';

import {useLocation} from 'react-router-dom';

import {dispatch, connect} from 'utils/state_manager';

import {Drawer, Box, Divider} from 'views/components';
import {AppBar, Toolbar, IconButton} from 'views/components';
import {Menu as MenuIcon} from 'views/icons';

import NavbarLogo from './navbar_top/NavbarLogo';
import NavbarServices from './navbar_services/NavbarServices';
import NavbarUser from './navbar_top/NavbarUser';
import NavbarAccount from './navbar_top/NavbarAccount';

const NavBar = (props) => {
  const {
    account,
    setAccount,
  } = props;

  const [drawerOpen, setDrawerOpen] = React.useState(false);

  const location = useLocation();

  React.useEffect(() => {
    setDrawerOpen(false);
  }, [location.pathname]);

  return (
    <>
      <AppBar
        position="static"
        sx={{
          bgcolor: 'navbar.main',
          color: 'navbar.text',
        }}
      >
        <Toolbar>
          <IconButton
            size="large"
            edge="start"
            color="inherit"
            sx={{mr: 2}}
            onClick={() => setDrawerOpen(true)}
          >
            <MenuIcon />
          </IconButton>
          <NavbarLogo />
        </Toolbar>
      </AppBar>
      <Drawer
        sx={{
          'width': 240,
          'flexShrink': 0,
          '& .MuiDrawer-paper': {
            width: 240,
            boxSizing: 'border-box',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
          },
        }}
        PaperProps={{
          sx: {
            backgroundColor: 'navbar.main',
          },
        }}
        onClose={() => setDrawerOpen(false)}
        open={drawerOpen}
        anchor="left"
      >
        <Box sx={{
          my: 2,
          ml: 2,

          display: 'flex',
          alignItems: 'center',
          flexWrap: 'wrap',
        }}>
          <NavbarLogo />
        </Box>
        <Box sx={{
          my: 1,
          mx: 2,
        }}>
          <NavbarUser />
          <NavbarAccount account={account} setAccount={setAccount} />
        </Box>
        <Divider sx={{borderColor: 'grey.400'}}/>
        <Box sx={{
          flex: 1,
          minHeight: 0,
          overflowY: 'auto',
        }}>
          <NavbarServices account={account} />
        </Box>
      </Drawer>
    </>
  );
};

NavBar.propTypes = {
  account: PropTypes.oneOf(['care', 'recruiter', 'ops']).isRequired,
  setAccount: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, dispatch)(React.memo(NavBar));
